import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation, useQuery } from '@apollo/react-hooks'
import { LATEST_PRIVACY_POLICY } from '../queries'
import { Markdown } from '../../../components/markdown/Markdown'
import { useAntdMessageApi, useUser } from '../../../providers'
import { ACCEPT_PRIVACY_POLICY } from '../mutations'
import { useHistory } from 'react-router-dom'
import { ROUTES } from '../../navigation'
import { cleanUpGraphQLErrorMessage } from '../../../utils/helper.utils'
import LoadingSpinner from '../../../components/loadingSpinner'
import {
	StyledContent,
	StyledSystemSection,
	StyledAcceptButton,
	StyledCenteredContainer
} from '../../license/containers/styles'

export const TermsOfUse = () => {
	const [t] = useTranslation()
	const history = useHistory()
	const messageApi = useAntdMessageApi()
	const { user } = useUser()

	const { data, loading, error } = useQuery(LATEST_PRIVACY_POLICY, {
		fetchPolicy: 'network-only'
	})

	const latest = data?.latestTermsOfUse

	const [acceptTerms] = useMutation(ACCEPT_PRIVACY_POLICY, {
		onCompleted: () => {
			messageApi?.open({
				type: 'success',
				content: t('core.privacyPolicy.acceptSuccess')
			})
			user.hasAcceptedLatestTermsOfUse = true
			history.push(ROUTES.home)
		},
		onError: error => {
			messageApi?.open({
				type: 'error',
				content: t('core.privacyPolicy.acceptError', {
					message: cleanUpGraphQLErrorMessage(error.message)
				})
			})
		}
	})

	const handleAccept = () =>
		acceptTerms({ variables: { termsOfUseId: latest?.id } })

	if (loading) {
		return (
			<StyledContent>
				<StyledCenteredContainer>
					<LoadingSpinner />
				</StyledCenteredContainer>
			</StyledContent>
		)
	}

	if (error) {
		return (
			<StyledContent>
				<StyledCenteredContainer>
					<p>{t('core.privacyPolicy.error')}</p>
				</StyledCenteredContainer>
			</StyledContent>
		)
	}

	if (!latest) {
		return (
			<StyledContent>
				<StyledCenteredContainer>
					<p>{t('core.privacyPolicy.empty')}</p>
				</StyledCenteredContainer>
			</StyledContent>
		)
	}

	return (
		<StyledContent>
			<StyledSystemSection>
				<Markdown>{latest.text}</Markdown>
			</StyledSystemSection>

			<StyledAcceptButton type="primary" onClick={handleAccept}>
				{t('core.privacyPolicy.accept')}
			</StyledAcceptButton>
		</StyledContent>
	)
}
